import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = {
  class: "modal-box w-[90%] max-w-[800px] p-0"
};
const _hoisted_3 = {
  class: "grid md:grid-cols-12"
};
const _hoisted_4 = {
  class: "md:col-start-1 md:col-span-5 flex overflow-hidden rounded-xl"
};
const _hoisted_5 = {
  class: "flex flex-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500"
};
const _hoisted_6 = {
  class: "md:col-start-6 md:col-span-7"
};
const _hoisted_7 = {
  class: "p-4"
};
export default {
  __name: 'ModalComponent',
  props: {
    name: {
      type: String,
      default: 'modal',
      require: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("dialog", {
        id: __props.name,
        class: "modal"
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "image")])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "content")])])])])], 8, _hoisted_1)]);
    };
  }
};